import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import echarts from '../config'

function getLevelOption () {
  return [
    {
      itemStyle: {
        borderColor: '#777',
        borderWidth: 0,
        gapWidth: 1
      },
      upperLabel: {
        show: false
      }
    },
    {
      itemStyle: {
        borderColor: '#555',
        borderWidth: 5,
        gapWidth: 1
      },
      emphasis: {
        itemStyle: {
          borderColor: '#ddd'
        }
      },
      upperLabel: {
        color: '#f0f0f0',
        fontWeight: 'bolder'
      }
    },
    {
      colorSaturation: [0.35, 0.5],
      itemStyle: {
        borderWidth: 5,
        gapWidth: 1,
        borderColorSaturation: 0.6
      },
      upperLabel: {
        color: '#e0e0e0',
        fontWeight: 'bolder'
      }
    }
  ]
}

function applyChartConfig (data, options = {}) {
  return {
    tooltip: {
      formatter: function (info) {
        const value = info.value
        const treePathInfo = info.treePathInfo
        const treePath = []
        for (let i = 1; i < treePathInfo.length; i++) {
          treePath.push(treePathInfo[i].name)
        }
        return [
          '<div class="tooltip-title">' +
          echarts.format.encodeHTML(treePath.join('/')) +
          '</div>',
          'Value: ' + echarts.format.addCommas(value)
        ].join('')
      }
    },
    series: [
      {
        type: 'treemap',
        label: {
          show: true,
          formatter: '{b}'
        },
        scaleLimit: {
          min: 1, // Prevent zooming out beyond original scale
          max: 10 // Optional: prevent too much zoom-in
        },
        upperLabel: {
          show: true,
          height: 30
        },
        data,
        levels: getLevelOption()
      }
    ]
  }
}

function TreeMap ({ height, data }) {
  const chartRef = useRef(null)
  const chartInstanceRef = useRef(null)

  useEffect(() => {
    if (chartRef.current && !chartInstanceRef.current) {
      chartInstanceRef.current = echarts.init(chartRef.current)
      window.addEventListener('resize', chartInstanceRef.current.resize)
    }

    return () => {
      if (chartInstanceRef.current) {
        window.removeEventListener('resize', chartInstanceRef.current.resize)
        chartInstanceRef.current.dispose()
        chartInstanceRef.current = null
      }
    }
  }, [])

  useEffect(() => {
    if (chartInstanceRef.current) {
      const chart = chartInstanceRef.current
      chart.setOption(applyChartConfig(data || []))
    }
  }, [data])

  return (
    <div style={{ height }} ref={chartRef} />
  )
}

TreeMap.propTypes = {
  height: PropTypes.number.isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.any,
    children: PropTypes.array
  }))
}

export default TreeMap
